import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { TiInfoOutline } from "react-icons/ti";
import { axios } from "../../../../Global";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";

export default function EditCandidatePopup({
  edit,
  setEdit,
  arrivalNotificationArray,
  camps,
  candidates,
  arrivalId,
  setUpdateData,
}) {
  const [loading, setLoading] = useState();
  const preValue = edit?.candidate;
  const isGroup = edit?.isGroup;
  const [arrivalStatus, setArrivalStatus] = useState(
    isGroup ? "" : preValue?.arrival_status
  );
  const [selectedCamp, setSelectedCamp] = useState(
    isGroup ? "" : preValue?.camp_id
  );
  const [campMapLink, setCampMapLink] = useState(
    isGroup ? "" : preValue?.google_map_link
  );
  const [advanceGiven, setAdvanceGiven] = useState(
    isGroup ? "" : preValue?.cash_advance
  );
  const [advanceAmount, setAdvanceAmount] = useState(
    isGroup ? "" : preValue?.cash_advance_amount
  );
  const [borderNumber, setBorderNumber] = useState(
    isGroup ? "" : preValue?.border_number
  );
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const temp = [...edit.value];
      const candidate = temp.map((ele) => {
        ele.cash_advance = advanceGiven;
        ele.cash_advance_amount = advanceAmount;
        ele.camp_id = selectedCamp;
        ele.border_number = borderNumber || "-";
        ele.arrival_status = arrivalStatus;
        ele.google_map_link = campMapLink;
        return ele;
      });
      const body = { candidate };
      await axios.put(
        `/dashboard/arrival-notification/${arrivalId}/candidate-edit`,
        body,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUpdateData((p) => !p);
      dispatch(setAppError({ msg: "Successfully updated", color: "success" }));
      setEdit({});
      setLoading(false);
      setArrivalStatus("");
      setSelectedCamp("");
      setCampMapLink("");
      setAdvanceGiven("");
      setAdvanceAmount("");
      setBorderNumber("");
    } catch (error) {
      setArrivalStatus("");
      setSelectedCamp("");
      setCampMapLink("");
      setAdvanceGiven("");
      setAdvanceAmount("");
      setBorderNumber("");
      setLoading(false);
      setEdit({});
      dispatch(setAppError({ msg: error?.response?.data?.message }));
    }
  };

  useEffect(() => {
    if (!isGroup) {
      setArrivalStatus(preValue?.arrival_status);
      setSelectedCamp(preValue?.camp_id);
      setCampMapLink(preValue?.google_map_link);
      setAdvanceGiven(preValue?.cash_advance);
      setAdvanceAmount(preValue?.cash_advance_amount);
      setBorderNumber(preValue?.border_number);
    }
  }, [isGroup, preValue]);

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        edit.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-md w-full h-auto max-h-[30rem]  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col p-6 overflow-y-scroll pt-28">
        <h1 className="text-xl font-semibold self-start">
          Edit Candidate List
        </h1>
        <form
          className="w-full flex flex-col justify-center items-center gap-4 my-3"
          onSubmit={handleSubmit}
        >
          <div className="w-full flex flex-col gap-1">
            <label className="text-sm">Select Arrival Status</label>
            <select
              className="select select-sm select-bordered"
              required
              value={arrivalStatus}
              onChange={(e) => setArrivalStatus(e.target.value)}
            >
              <option value="" hidden>
                Select an Arrival Status
              </option>
              <option key={"arrived"} value={"Arrived"}>
                Arrived
              </option>
              <option key={"notarrived"} value={"Not Arrived"}>
                Nor Arrived
              </option>
              <option key={"missing"} value={"Missing"}>
                Missing
              </option>
            </select>
          </div>
          <div className="w-full flex flex-col gap-1">
            <label className="text-sm">Select Camp</label>
            <select
              className="select select-sm select-bordered"
              required
              value={selectedCamp}
              onChange={(e) => setSelectedCamp(e.target.value)}
            >
              <option value="" hidden>
                Select Camp
              </option>
              {camps.map((camp) => (
                <option key={camp?.id} value={camp?.id}>
                  {camp?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full flex flex-col gap-1">
            <label className="text-sm">Google Map Link</label>
            <input
              required
              type="text"
              className="input-md"
              defaultValue={campMapLink}
              onChange={(e) => setCampMapLink(e.target.value)}
              placeholder="Google Map Link"
            />
          </div>
          <div className="w-full flex flex-col gap-1">
            <label className="text-sm">Cash Advance Given ? </label>
            <select
              className="select input select-sm select-bordered"
              value={advanceGiven}
              onChange={(e) => setAdvanceGiven(e.target.value)}
              required
            >
              <option value="" hidden>
                Select Option
              </option>
              <option key={"yes"} value={"YES"}>
                YES
              </option>
              <option key={"no"} value={"NO"}>
                NO
              </option>
            </select>
          </div>
          {advanceGiven === "YES" && (
            <div className="w-full flex flex-col gap-1">
              <label className="text-sm">Cash Advance Amount</label>
              <input
                type="number"
                className="input-md"
                value={advanceAmount}
                onChange={(e) => setAdvanceAmount(e.target.value)}
                placeholder="Cash Advance Amount"
              />
            </div>
          )}
          {!edit.isGroup && (
            <div className="w-full flex flex-col gap-1">
              <label className="text-sm">Border Number</label>
              <input
                type="text"
                className="input-md"
                placeholder="Border Number"
                defaultValue={borderNumber}
                onChange={(e) => {
                  setBorderNumber(e.target.value);
                }}
              />
            </div>
          )}

          <div className="flex gap-3 min-w-fit  w-full">
            <button
              className="p-1 max-w-sm w-full rounded-md ring-1 ring-slate-600"
              onClick={() => {
                setEdit((p) => {});
                setArrivalStatus("");
                setSelectedCamp("");
                setCampMapLink("");
                setAdvanceGiven("");
                setAdvanceAmount("");
                setBorderNumber("");
              }}
              type="button"
            >
              Cancel
            </button>
            <button
              className="p-1 max-w-sm w-full rounded-md ring-1 ring-red text-white bg-red"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
